<list-view [liste]="listeParametres" (onLoadEnd)="refreshListe()"></list-view>